// components/building/BuildingHeader.tsx
/**
 * @mockup /design/mockups/01-mobile-building-landing.png
 * @description Hero section with building photo, name, and neighborhood
 * Design System: Warm Sophistication - Fraunces display font, warm overlay
 */
import { MapPin } from 'lucide-react';
import type { Building } from '../../types/database';
import { PLACEHOLDER_IMAGES } from '../../lib/mockData';

interface BuildingHeaderProps {
  building: Building;
  imageUrl?: string;
}

export function BuildingHeader({ building, imageUrl }: BuildingHeaderProps) {
  // Priority: imageUrl prop > building.hero_image_url > placeholder
  const heroImage = imageUrl || building.hero_image_url || PLACEHOLDER_IMAGES.building;

  return (
    <div className="relative w-full aspect-hero overflow-hidden bg-bg-subtle">
      {/* Building Image */}
      <img
        src={heroImage}
        alt={`${building.name} Exterior`}
        className="w-full h-full object-cover"
      />

      {/* Gradient Overlay - Warm tone overlay for brand consistency */}
      <div className="hero-overlay absolute inset-0 pointer-events-none" />

      {/* Text Overlay */}
      <div className="absolute bottom-0 left-0 w-full p-5 text-text-inverse">
        <h1 className="font-display text-display-xl mb-1.5 leading-tight drop-shadow-md" style={{ textShadow: '0 2px 8px rgba(0,0,0,0.5)' }}>
          {building.name}
        </h1>
        <div className="flex items-center text-text-inverse/90 text-body-md font-medium drop-shadow-sm">
          <MapPin size={16} className="mr-1.5" />
          <span>{building.city}</span>
        </div>
      </div>
    </div>
  );
}
